import i18n from "../../service/i18/i18n";
import {LocalData} from "../../service/localStorage";
import { getDefaultLanguageWithGlobal } from "../module";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isTomorrow from "dayjs/plugin/isTomorrow";
import isYesterday from "dayjs/plugin/isYesterday";

dayjs.extend(isToday);
dayjs.extend(isTomorrow);
dayjs.extend(isYesterday);


const localData = new LocalData();

export function operator_info(data) {
  set_accessToken(data.accessToken);
  set_id(data.userId);
  set_refreshToken(data.refreshToken);
  set_username(data.username);
  set_name(data.name);
}

export function reset() {
  localData.remove("adminToken")
  localData.remove("accessToken");
  localData.remove("refreshToken");
  localData.remove("id");
  window.location.reload();
}

export function resetToLogin() {
  localData.remove("adminToken")
  localData.remove("accessToken");
  localData.remove("refreshToken");
  localData.remove("id");

}


export function set_username(data) {
  localData.set("username", data)
}

export function get_username() {
  return localData.get("username");
}

export function set_name(data) {
  localData.set("name", data);
}

export function get_name() {
  return localData.get("name");
}

export function set_accessToken(data) {
  localData.set("accessToken", data);
}

export function get_accessToken() {
  return localData.get("accessToken");
}


export function set_adminToken(data) {
  localData.set("adminToken", data);
}

export function get_adminToken() {
  return localData.get("adminToken");
}

export function set_refreshToken(data) {
  localData.set("refreshToken", data);
}

export function get_refreshToken() {
  return localData.get("refreshToken");
}

export function set_defaultLocation(data) {
  localData.set("defaultLocation", JSON.stringify(data));
}

export function get_defaultLocation() {
  return JSON.parse(localData.get("defaultLocation"));
}

export function set_currencyCode(data) {
  localData.set("currencyCode", data);
}

export function get_currencyCode() {
  return localData.get("currencyCode");
}

export function set_lang(data) {
  localData.set("lang", data);
}

export function get_lang() {
try {
    if(localStorage.getItem("lang")){
      return localStorage.getItem("lang")
    }else{
      return getDefaultLanguageWithGlobal(global.config.defaultLanguage).lang
    }
} catch (error) {
  console.log("ewfewfef " , error )
  return "en"
}
}
export function set_direction(data) {
  localData.set("direction", data);
}

export function get_direction() {
  return localData.get("direction");
}

export function set_calendarType(data) {
  localData.set("calendarType", data);
}

export function set_tab_orderTypes(data) {
  localData.set("tab_orderTypes", JSON.stringify(data));
}

export function get_tab_orderTypes() {
  return global.config.dispatcherSettings ? global.config.dispatcherSettings.orderTypes : [];
}


export function set_settings_dispatcher(data) {
  console.log("gasfewaew " , data)
  localData.set("settings", JSON.stringify(data));
}

export function get_settings_dispatcher() {
  return localData.get("settings") ? JSON.parse(localData.get("settings")) : {};
}

export function get_calendarType() {
  return localData.get("calendarType");
}

export function set_id(data) {
  localData.set("id", data);
}

export function get_id() {
  return localData.get("id");
}

export function set_project(data) {
  localData.set("project", JSON.stringify(data));
}

export function get_project() {
  return JSON.parse(localData.get("project"));
}
 

export function get_dateFormat() {
  return `${JSON.parse(localStorage.getItem("settings"))?.dateFormat}`.toUpperCase();
}

export function get_timeFormat() {
  let xx = JSON.parse(localStorage.getItem("settings"))?.timeFormat;
  if(xx == "12h"){
    return "hh:mm a"
  }else{
    return "HH:mm"
  }
}
 
export function get_ALLFormat() {
  let xx = JSON.parse(localStorage.getItem("settings"))?.timeFormat;
  if(xx == "12h"){
    return  `${get_dateFormat()} , hh:mm a` 
  }else{
    return  `${get_dateFormat()} , HH:mm` 
  }
}
 
export function get_monthDayFormat() {
    let xx = {
        'yyyy/MM/dd': 'MM/dd',
        'dd/MM/yyyy': 'dd/MM',
        'MM/dd/yyyy': 'MM/dd',
        'yyyy.MM.dd': 'MM.dd',
        'dd.MM.yyyy': 'dd.MM',
        'MM.dd.yyyy': 'MM.dd',
        'yyyy-MM-dd': 'MM-dd',
        'dd-MM-yyyy': 'dd-MM',
        'MM-dd-yyyy': 'MM-dd',
        'dd MMMM, yyyy': 'dd MMMM',
        'dd MMMM yyyy': 'dd MMMM',
        'MMMM dd, yyyy': 'MMMM dd',
        'MMMM dd yyyy': 'MMMM dd',
    };

      let xxw = JSON.parse(localStorage.getItem("settings"))?.timeFormat;
      if(xx == "12h"){
        return  `${xx[xxw] || 'MMMM dd'} , hh:mm a` 
      }else{
        return  `${xx[xxw] || 'MMMM dd'} , HH:mm` 
      }

 }


export function checkTimestamp(timestamp) {
  const date = new Date(timestamp);
  const today = new Date();

  // مقادیر سال و روز برای مقایسه
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  const currentYear = today.getFullYear();


  const d = dayjs(timestamp);
  
  console.log("checkTimestamp ", timestamp , date , today, d.isToday() , d.isTomorrow() , d.isYesterday())



  // بررسی شرایط مختلف
  if (year === currentYear) {
    if (d.isToday()) {
      return `${get_timeFormat()}`  // امروز
    }

    if (d.isTomorrow()) {
      return `[${i18n.t("Tomorrow")}], ${get_timeFormat()}`  // فردا
    }

    if (d.isYesterday()) {
      return `[${i18n.t("Yesterday")}], ${get_timeFormat()}`  // دیروز
    }
    return `MMM DD, ${get_timeFormat()}`; // دیروز و امروز و فردا نیست

  } else {
    return get_ALLFormat(); // هر سالی بجز امسال

  }
}

